// Work end must stay on or after work start. When work start advances past an
// already-selected work end, drop the now-invalid work end so the picker's
// minDate and the step validation stay consistent instead of blocking progress.
export function reconcileWorkEndDate(
    workStartDate: string | null | undefined,
    workEndDate: string | null | undefined,
): string | null {
    if (workStartDate && workEndDate && workEndDate < workStartDate) {
        return null;
    }
    return workEndDate ?? null;
}
